import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

import { AuthService } from "@lantern/app/core/auth/auth.service";

@Injectable()
export class IsAdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    return this.authService.isAdmin() || this.navigateToNoPermission();
  }

  private navigateToNoPermission(): false {
    this.router.navigateByUrl("/not-found");
    return false;
  }
}
